import type { FaireProductEntity } from "../../entity_types/product";

export const p_ru9hrjs75q: FaireProductEntity = {
  token: "p_ru9hrjs75q",
  type: "product",
  name: "LM-CT-1001 Puffer Jacket - Light Blue",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/c4445ea0652cdd0e76e69d36110f8d4ebddda3f6814b142de2d8a2b63eeb72d7.jpeg",
  galleryImageUrls: [],
  priceDollars: 44.5,
  description: "This light blue puffer jacket by Girlie Girl Originals offers reliable warmth and southern-inspired flair. The jacket is a versatile outerwear choice for seasonal wear and complements varied outfits and activities.",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:19.994Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
